/* clean-up of the mess from lookup */

import React, {useCallback, useEffect, useState} from 'react';
import { ApolloQueryResult } from "@apollo/client";
import { graphqlFindResults } from "../../graphql-helpers";
import { Button, Tooltip} from "@mui/material";
import {Warning} from "@mui/icons-material";
import {Select, SelectProps} from "./Select";


export type GraphQlSelectProps<Type> = {
    value: Type | Type[]|null,
    onChange: (CallbackFuncProps)=>void,
    name: string,
    inTable?: boolean,
    labelField?:string,
    className?:string,
    defaultOption?: Type|number|string,
    queryResult: ApolloQueryResult<Type>,
    setEditValue:(value:string)=>void,
    allowBlank?: boolean,
    blankLabel?: string,
    disabled?: boolean,
    renderOption?: any,
    label?:string,
    setSearchTerm?: (string)=>void,
    renderOptionString?:(Type)=>string
    fill: boolean,
    multiple: boolean,
    filterOptions?:(options:Type[])=>Type[],
    extraOptions?:Type[],
    width: any

};

export function GraphQlSelect<Type extends { id: any,trashed?:boolean}>(props: GraphQlSelectProps<Type>): React.ReactElement {
    const value = props.value as string|number|Type;
    const valueArray = props.value as unknown as Type[]|number[]|string[]??[];
    const [currentOptions, setCurrentOptions] = useState<Type[]>([]);
    const [allowEdit, setAllowEdit] = useState(false);
    const [editValue,setEditValue] = useState('');
    console.log('CCACS render with',value,valueArray,editValue);
    useEffect(() => {
        let options:Type[] = [];
        // find the values, optionally add a blank entry
        // and filter
        if(props.queryResult.loading||props.queryResult.error) {
            console.log('CCACS1 loading/error');
            options = [...currentOptions];
        } else {
            options = graphqlFindResults(props.queryResult.data);
            console.log('CCACS1 real data',options);
            options = [...options];
            if (props.filterOptions) {
                options = props.filterOptions(options);
            }
        }
        if(props.extraOptions && Array.isArray(options)) {
            options = options.concat(props.extraOptions);
        }
        if (Array.isArray(options)) {
            setCurrentOptions(options);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.queryResult.loading,props.queryResult.error,props.queryResult.data]);
    /*useEffect(()=>{
        console.log('value -> CCACS clear search term!');
        if(props.setSearchTerm) {
            props.setSearchTerm('');
        }
        setEditValue('');
    },[props.value]);*/

    const doAllowEdit = function () {
        setAllowEdit(true);
    };
    function isSelected(id): boolean {
        if(props.multiple) {
            return !!(valueArray as Type[]).find((option)=>option.id==id);
        } else {
            return (value as Type)?.id == id;
        }
    }
    // debug - look for changes in empty array
    const [ov,setOv] = useState(props.value);
    useEffect(()=>{
        setOv(props.value);
    },[props.value]);
    const sendValue = (props.multiple && !Array.isArray(props.value))?[]:props.value;
    console.log('interior value is',ov===sendValue,ov===props.value);
    //end debug

    const newProps:any = {
        options:currentOptions,
        loading:props.queryResult.loading,
        value:sendValue
    };
    const setSearchTerm = useCallback((evt,term,meaning)=>{
        console.log('CCACS SET',term,evt,meaning);
        if(!evt||(props.multiple && meaning=='reset')) return;
        console.log('CCACS2');
        if(!props.multiple) {
            setEditValue(term);
        }
        if(props.multiple) {
            if(props.setEditValue) {
                props.setEditValue(term);
                return;
            } else {
                setEditValue(term);
            }
        }
        console.log('value -> CCACS set search term!',term);
        if(props.setSearchTerm) {
            props.setSearchTerm(term);
        }
    },[props.labelField,props.setSearchTerm]);
    const onBlur = useCallback(newProps.onBlur = (evt)=>{
        console.log('CCACS blur!');
        if(editValue) {
            setEditValue('');
        }
    },[!!editValue]);
    if (!Array.isArray(currentOptions)) {
        return <div>An error has occurred</div>;
    }
    if(!allowEdit) {
        if (!props.queryResult.loading && props.value !== undefined && props.value !== null) {
            if (props.multiple) {
                currentOptions.forEach((option) => {
                    if (isSelected(option?.id)) {
                        if (option?.trashed) {
                            return <Tooltip title="This value is no longer valid for selection.  Changing this value cannot be undone." ><Button sx={{width:props.fill?'100%':''}} variant="contained" startIcon={<Warning/>} onClick={doAllowEdit}>Edit this field</Button></Tooltip>
                        }
                    }
                })
            }
        }
    }
   if(props.setSearchTerm) {

        newProps.setSearchTerm = setSearchTerm;
        //newProps.searchTerm = editValue;
   }
   if(editValue && !props.multiple) {
    // for auto-completes, we need to fake an entry to show this in the list
    // for tags, that isn't necessary for some reason
       newProps.value = editValue;
       newProps.onBlur = onBlur;
   }
   console.log('CCACS1','render with',newProps);
   return <Select<Type> {...props} {...newProps}/>;
}

